import Splide from '@splidejs/splide'

new Splide( '.splide', {
	'height': '500px'
}).mount();